import { useAuth } from "@qure/qure-auth";
import { t } from "i18next";
import Image from "next/image";
import Link from "next/link";

const Maintenance = () => {
  const { error, userInfo, isLoading } = useAuth();
  const authErrorStatus = error?.response?.status;
  const isUnderMaintenance =
    !isLoading && (authErrorStatus > 500 || error?.code == "ERR_NETWORK");

  if (!isUnderMaintenance) {
    return null;
  }

  return (
    <div className="flex h-full bg-[#0C1723] flex-col justify-center items-center space-y-6">
      <div className="relative w-[312px] h-[232px] md:w-[588px] md:h-[436px]">
        <Image
          fill
          alt="error"
          src="/assets/images/maintenance-image.svg"
          className="object-contain"
        />
      </div>
      <div
        onClick={() => {
          window.location.reload();
        }}
        className="bg-gray-800 text-teal-300 text-lg md:text-2xl py-5 md:py-6 px-20 rounded-xl cursor-pointer"
      >
        {t("refresh_page")}
      </div>
      <div className="flex flex-col items-center justify-center text-lg">
        <div className="text-gray-500">{t("under_maintenance")}</div>
        <div className="text-gray-500">{t("refresh_after_sometime")}</div>
      </div>
    </div>
  );
};

export default Maintenance;
